import React from 'react';
import AnnouncementGrid from '../../components/AnnouncementGrid/AnnouncementGrid';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import SideNavBar from '../../components/SideNavBar/SideNavBar';
import Loader from '../../StaticComponent/Loader';
import './announcement.css';


function Announcement() {
    const [editAnnouncementData, setEditAnnouncementData] = React.useState({});
    const [flag, setFlag] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [hideContainer, setHideContainer] = React.useState(true);
    let breadCrumbsData = [
        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'Admin', isActive: true, path: '/admin/accountbranding' },
        { title: 'Announcements', isActive: false, path: '' },
    ];

    const editAnnouncement = (data) => {

        setEditAnnouncementData(data);
        setHideContainer(false);
    };

    const updateAnnoucementData = (data) => {
        switch (data) {
            case 'cancel':
                setEditAnnouncementData({});
                break;
            case 'update':
                setEditAnnouncementData({});
                setFlag(!flag);
                break;
            default:
                break;
        }
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="col-md-10 offset-md-2 content-card">
                {hideContainer == false ? <SideNavBar
                    form="announcement"
                    handleData={(data) => {
                        updateAnnoucementData(data);
                    }}
                    editData={editAnnouncementData}
                    hideContainer={hideContainer}
                    setHideContainer={() => setHideContainer()}
                /> : null}
                <BreadCrumbs data={breadCrumbsData} />
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-between">
                            <h5 className="bold-text tt-bold font-18">Announcements</h5>
                            <a
                                href="#"
                                className="btn hive-btn-primary"
                                type="button"
                                // data-bs-toggle="offcanvas"
                                // data-bs-target="#offcanvasRight"
                                // aria-controls="offcanvasRight"
                                onClick={() => setHideContainer(false)}
                            >
                                <img className="me-2" src="/Images/plus.svg" />
                                New Announcement
                            </a>
                        </div>
                    </div>
                    <AnnouncementGrid
                        editAnnouncement={(editData) => {
                            editAnnouncement(editData);
                        }}
                        setIsLoading={() => { setIsLoading(true) }}
                        updateData={flag}
                    />
                </div>
            </div>
        </>
    );
}

export default Announcement;
